<app-side-dialog class="min-w-[700px]" (closeDialog)="onCancelClick()">
  <div dialogHeader>
    <h2>{{ title() }}</h2>

    @if (!dialogData.viewMode) {
      <span class="text-shikenso-purple-base-60 text-sm">
        {{
          dialogData.creatorName
            ? ('components.briefingNotes.creatorDescription'
              | translate
                : {
                    creatorName: dialogData.creatorName,
                  })
            : ('components.briefingNotes.globalDescription' | translate)
        }}
      </span>
    }
  </div>

  <div dialogContent>
    <app-briefing-notes [data]="dialogData" (cancelled)="onCancelClick()" (saved)="onSave($event)" />
  </div>
</app-side-dialog>
